import { bold } from "./bold.js";
import { code, codeBlock } from "./code.js";
import { italic } from "./italic.js";
import { header } from "./header.js";
import { strike } from "./strike.js";
import { underline } from "./underline.js";
import { olist } from "./olist.js";
import { ulist } from "./ulist.js";
import { quote } from "./quote.js";
import { link } from "./link.js";
import { todo } from "./todo.js";
import { image } from "./image.js";
import { redo } from "./redo.js";
import { undo } from "./undo.js";
import { fullscreen } from "./fullscreen.js";
import { preview } from "./preview.js";
export var defaultCommands = {
  undo,
  redo,
  bold,
  italic,
  header,
  strike,
  underline,
  quote,
  olist,
  ulist,
  todo,
  link,
  image,
  code,
  codeBlock,
  fullscreen,
  preview
};
export var getCommands = () => Object.keys(defaultCommands).filter(key => !/^(fullscreen|preview)/.test(key)).map(key => defaultCommands[key]);
export var getModeCommands = () => [preview, fullscreen];
export { bold, code, codeBlock, italic, header, strike, underline, olist, ulist, quote, link, todo, image, redo, undo, fullscreen, preview };